/* One Galosh — Plaza + header behaviour.
   Two jobs only:
   1. The Plaza picture and the quest row are ONE map — hovering or focusing
      either half lights the other. This is the fix for the sketch's duplicated
      navigation (see site-design-direction.md §"The one conflict").
   2. "Choose your shoes" — a 7-option cursor picker in the header, off
      (plain arrow) by default. Clicking the active option again clears it.
      Persisted per visitor in localStorage; wrapped because Shopify preview
      frames and privacy modes can throw on access.
   Re-runs on Shopify's section load/unload events so it survives theme-editor
   re-renders. */
(function () {
  'use strict';

  var CURSOR_KEY = 'og-cursor-choice';

  function lane(el) { return el.getAttribute('data-og-lane'); }

  function bindLanes(scope) {
    var parts = scope.querySelectorAll('[data-og-lane]');
    Array.prototype.forEach.call(parts, function (el) {
      if (el.dataset.ogBound === '1') return;
      el.dataset.ogBound = '1';
      var name = lane(el);
      var set = function (on) {
        var all = document.querySelectorAll('[data-og-lane="' + name + '"]');
        Array.prototype.forEach.call(all, function (n) {
          n.classList.toggle('is-lit', on);
        });
      };
      el.addEventListener('mouseenter', function () { set(true); });
      el.addEventListener('mouseleave', function () { set(false); });
      el.addEventListener('focus', function () { set(true); });
      el.addEventListener('blur', function () { set(false); });
    });
  }

  function bindCursorPicker(scope) {
    var picker = scope.querySelector('[data-og-cursor-picker]');
    if (!picker || picker.dataset.ogBound === '1') return;
    picker.dataset.ogBound = '1';

    var opts = picker.querySelectorAll('[data-og-cursor-opt]');
    var summary = picker.querySelector('summary');
    var label = picker.querySelector('.og-cursor-picker__label');
    var defaultLabel = picker.getAttribute('data-og-cursor-default-label') || (label ? label.textContent : '');

    var read = function () {
      try { return localStorage.getItem(CURSOR_KEY) || ''; } catch (e) { return ''; }
    };
    var write = function (v) {
      try { localStorage.setItem(CURSOR_KEY, v); } catch (e) { /* private mode */ }
    };
    var apply = function (id) {
      var active = null;
      Array.prototype.forEach.call(opts, function (btn) {
        var isActive = btn.getAttribute('data-og-cursor-opt') === id;
        btn.setAttribute('aria-pressed', String(isActive));
        btn.classList.toggle('is-active', isActive);
        if (isActive) active = btn;
      });
      document.documentElement.style.cursor = active ? (active.getAttribute('data-og-cursor') || '') : '';
      /* the summary stays visible in the sticky header even while its menu
         is closed, so it needs to say which cursor is actually on, not just
         a static settings label */
      if (label) label.textContent = active ? (active.getAttribute('aria-label') || defaultLabel) : defaultLabel;
    };

    apply(read());

    Array.prototype.forEach.call(opts, function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-og-cursor-opt');
        var next = read() === id ? '' : id;
        apply(next);
        write(next);
        picker.removeAttribute('open');
      });
    });

    document.addEventListener('click', function (e) {
      if (picker.hasAttribute('open') && !picker.contains(e.target)) {
        picker.removeAttribute('open');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && picker.hasAttribute('open')) {
        picker.removeAttribute('open');
        if (summary) summary.focus();
      }
    });
  }

  function bind(root) {
    var scope = root || document;
    bindLanes(scope);
    bindCursorPicker(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }

  /* theme editor: sections are swapped in and out of the DOM */
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
  document.addEventListener('shopify:section:select', function (e) { bind(e.target); });
})();
